/*
 * kp-cart-drawer.js
 * Abre el cart drawer (panel lateral derecho) al agregar al carrito desde
 * cualquier flujo que NO use el custom element <product-form> de Dawn:
 *   - Formulario de la pagina de producto (buy-buttons, is:'product-form' inerte)
 *   - Sticky ATC bars (FoxTheme no esta definido en este theme)
 * Ademas cablea los enlaces al /cart (icono de carrito en headers kp) para
 * abrir el drawer en vez de navegar, con fallback nativo si el JS falla.
 *
 * Los quick-add de card-product SI usan <product-form> y los maneja Dawn
 * (product-form.js) -> aqui se ignoran para no duplicar el add.
 */
(function () {
  'use strict';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* Badge de cantidad en headers kp (data-kp-cart-count). Se refresca via
   * /cart.js: cubre adds propios, adds de Dawn (quick-add) y cambios de
   * cantidad dentro del drawer (via observer, debounced). */
  var badgeTimer = null;

  function setKpCartBadges(count) {
    var badges = document.querySelectorAll('[data-kp-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].hidden = count === 0;
    }
  }

  function refreshKpCartBadges() {
    if (!document.querySelector('[data-kp-cart-count]')) return;
    clearTimeout(badgeTimer);
    badgeTimer = setTimeout(function () {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (typeof cart.item_count === 'number') setKpCartBadges(cart.item_count);
        })
        .catch(function () { /* badge queda como esta */ });
    }, 300);
  }

  function observeDrawerForBadge() {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || !document.querySelector('[data-kp-cart-count]')) return;
    new MutationObserver(refreshKpCartBadges).observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawerForBadge);
  } else {
    observeDrawerForBadge();
  }

  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.closest('product-form')) return false; // lo maneja Dawn
    if (form.dataset && form.dataset.type === 'add-to-cart-form') return true;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function sectionsToRender(cartDrawer) {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function setLoading(form, on) {
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (!btn) return;
    if (on) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading', 'btn--loading');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading', 'btn--loading');
    }
    var spinner = form.querySelector('.loading-overlay__spinner, .loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  function showError(form, message) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var msg = form.querySelector('.product-form__error-message');
    if (msg) msg.textContent = message;
    if (wrapper) wrapper.removeAttribute('hidden');
    if (!wrapper && !msg) console.warn('[kp-cart-drawer]', message);
  }

  function onSubmit(evt) {
    var form = evt.target;
    if (!isAddToCartForm(form)) return;

    var cartDrawer = getCartDrawer();
    // Sin drawer en el DOM (ej. layout landing): dejar submit nativo -> /cart
    if (!cartDrawer) return;

    evt.preventDefault();

    var formData = new FormData(form);
    formData.append('sections', sectionsToRender(cartDrawer).join(','));
    formData.append('sections_url', window.location.pathname);

    setLoading(form, true);
    if (typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(document.activeElement);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          showError(form, data.description || data.message || 'No se pudo agregar el producto.');
          return;
        }
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        refreshKpCartBadges();
      })
      .catch(function (err) {
        console.error('[kp-cart-drawer] add error', err);
        // Fallback: ir a la pagina de carrito
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  function onCartLinkClick(evt) {
    var link = evt.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (!link) return;
    if (link.id === 'cart-icon-bubble') return; // ya lo cablea cart-drawer.js (Dawn)
    if (link.closest('cart-drawer')) return; // "Ver carrito" del drawer -> pagina completa
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return; // fallback nativo
    evt.preventDefault();
    cartDrawer.open(link);
  }

  document.addEventListener('submit', onSubmit, true); // capture: antes que Dawn
  document.addEventListener('click', onCartLinkClick);
})();
